export enum ZonesSort {
    CODE_ASC = 'properties.code',
    NAME_ASC = 'properties.name',
    MAXSPEED_ASC = 'properties.maxSpeed.value',
    TAGS_ASC = 'properties.tags',
    CODE_DESC = '-properties.code',
    NAME_DESC = '-properties.name',
    MAXSPEED_DESC = '-properties.maxSpeed.value',
    TAGS_DESC = '-properties.tags',
}
